import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import './styles.scss';

export default function FinalCtaSection() {
  return (
    <section className="plh-final">
      <div className="plh-final__inner">
        <Reveal>
          <p className="plh-eyebrow plh-eyebrow--light">Run a real project on us</p>
        </Reveal>
        <Reveal as="h2" delay={80}>
          Ninety days. Your real crews. Your real project. If it doesn&rsquo;t pay for itself —{' '}
          <span className="plh-accent--light">walk away.</span>
        </Reveal>
        <Reveal as="p" className="plh-final__lede" delay={160}>
          No credit card. No demo gauntlet. Full access to every tool on every plan, with
          unlimited subcontractor accounts from day one.
        </Reveal>
        <Reveal className="plh-final__ctas" delay={240}>
          <Link to="/signup" className="pl-btn pl-btn--primary pl-btn--shine">
            Start 90-day free trial
          </Link>
          <Link to="/contact_us" className="pl-btn pl-btn--outline-light">
            Talk to a builder
          </Link>
        </Reveal>
        <Reveal as="p" className="plh-final__checks plh-mono" delay={320}>
          <span>✓ 90 days free</span>
          <span>✓ No credit card</span>
          <span>✓ No commitment</span>
        </Reveal>
      </div>
    </section>
  );
}
